import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { getDataLayerVal } from "utils/datalayerextraction";

/***

## NATIVE CONTENT
1. if less than 1023 then reflow (already does this for advert A)
1a. init class (ajax)
2. else init class
***/

class NativeContent extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(options);
    this.url = this.element.data("url");
    this.cacheBust = this.element.data("cacheBust");
    this.async = this.element.data("ajaxAsync");
    if (!this.url) {
      throw new Error("Please supply a data-url attribute to load content.");
    }
    this.updateParameters();
    this.makeRequest();
    // this.reflowExtras();
  }

  qs() {
    if (window.mostThisObj) {
      return $.param(mostThisObj[0] || {});
    }
  }

  updateParameters() {
    if ($(this.element).data("ajaxParamReplacement")) {
      this.url = this.url
        .replace("storytoken=1", `storycode=${getDataLayerVal("StoryID")}`)
        .replace("navtoken=1", `navcode=${getDataLayerVal("NavCode")}`);
    }
  }

  makeRequest() {
    $.ajax({
      async: this.async || true,
      url: this.url,
      data: this.qs(),
      cache: this.cacheBust ? false : true,
      success: (data, status, xhr) => {
        if (status == "success" || data.length) {
          $(this.element).append(data);
          $(this.element).attr("data-content-loaded", "true");
          $(window).trigger("abacus:nativecontent:loaded", this.element);
        } else {
          $(this.element).append(
            `<p class="error">There was an error loading the content.</p>`
          );
        }
      }
    });
  }

  reflowExtras() {
    var mql = window.matchMedia("screen and (max-width: 1023px)");
    var html = $(this.element).html();
    if ($("body").hasClass("story-full-layout")) {
      $("#story #mobile-story-rhc-extra").append(html);
      $(this.element).remove();
    } else {
      if (mql.matches) {
        $(html).appendTo($("#story #mobile-story-rhc-extra .inner-sleeve"));
        $(this.element).remove();
      }
    }
  }
}

export { NativeContent };



// WEBPACK FOOTER //
// ./Javascript/core/classes/native-content-reflow-ajax.class.js